<template>
	<div>
		<h3>Requisitos PCI DSS (pcisecuritystandards.org)</h3>
		<h4>Qual integração sua loja utiliza?</h4>

		<b-row :class="{ 'mb-4': !selected }" class="m-0">
			<b-col
				v-for="(integration, index) in integrations"
				:key="index"
				:class="{ active: selected == integration }"
				class="item"
				cols="12"
				md="4"
				@click="select(integration)">
				{{ integration.text }}
			</b-col>
		</b-row>

		<b-row v-if="selected" class="pci m-0">
			<b-col cols="12" md="4">
				<h4>Nível PCI DSS obrigatório:</h4>
			</b-col>

			<b-col cols="12" md="8">
				<p v-html="getIntegrationPci"></p>
			</b-col>
		</b-row>

		<b-row v-if="selected && $store.state.form.pci.integration.pci > 0">
			<b-col class="confirm" cols="12">
				<p class="mt-3">
					Certificação PCI e seus níveis são necessários apenas em transações de cartão de crédito e débito.
				</p>

				<b-form-group :label-cols="$root.isMobile() ? '12' : '4'" class="mt-3" label="Empresa em conformidade?">
					<b-form-radio-group v-model="conformity" :options="groupOptions" name="conformity" />
				</b-form-group>
			</b-col>
		</b-row>

		<files-component
			v-if="selected && $store.state.form.pci.integration.pci > 0"
			ref="pci"
			:fileType="'pci'"
			:files="[]"
			:uploadedFiles="$store.state.form.uploadedDocuments.pci"
			:showIndex="false"
			:modal-id="'modal-confirm-document'"
			label="Cópia do certificado de conformidade PCI" />

		<confirm-modal-component type="document" modal-id="modal-confirm-document" />
	</div>
</template>

<script>
import integrations from "@/static/integrations";


import FilesComponent from "@/components/Form/Inputs/FilesComponent";
import ConfirmModalComponent from "@/components/Form/ConfirmModalComponent";
export default {
	name: "IntegrationsFormComponent",
	props: ["validationTrigger"],
	components: {
		FilesComponent,
		ConfirmModalComponent,
	},
	data() {
		return {
			groupOptions: [
				{
					text: this.$t("messages.yes"),
					value: true,
				},
				{
					text: this.$t("messages.no"),
					value: false,
				},
			],
			integrations: integrations,
		};
	},
	mounted() {
		this.$store.dispatch("updateStep", this.step);
	},
	watch: {
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.selected);
		},
		isValid() {
			this.$emit("setReadyToSubmit", this.selected);
		},
	},
	computed: {
		isValid() {
			return this.selected;
		},
		selected: {
			get() {
				return this.$store.state.form.pci.integration;
			},
			set(value) {
				this.$store.commit("setPci", {
					key: "integration",
					value,
				});
			},
		},
		conformity: {
			get() {
				return this.$store.state.form.pci.conformity;
			},
			set(value) {
				this.$store.commit("setPci", {
					key: "conformity",
					value,
				});
			},
		},
		getIntegrationPci() {
			let pci = `N/A - Integração não necessita certificado PCI`;

			if (this.selected.pci === 1) {
				pci = `SAQ - A`;
			}

			if (this.selected.pci === 2) {
				pci = `SAQ – D (&lt; 6 milhões de transações de cartão de crédito e débito por ano) <br/>
					AoC (&gt; 6 milhões de transações de cartão de crédito e débito por ano)`;
			}

			return pci;
		},
		step() {
			return this.$store.state.form.step;
		},
	},
	methods: {
		select(integration) {
			this.selected = integration;

			if (integration.pci === 0) {
				this.conformity = true;
			}

			this.$emit("enable", this.selected.length);

			if (!this.$root.isMobile()) {
				return;
			}

			window.scrollTo({
				top: 9999,
				left: 0,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";

h4 {
	color: #32302f;
	font-family: "Montserrat";
	font-size: 14px;
	font-weight: bold;
	letter-spacing: -0.14px;
	line-height: 49px;
}

.item {
	background-color: #f6f6f6;
	border-radius: 28px;
	color: #686361;
	font-family: "Montserrat";
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 25px;
	text-align: center;
	cursor: pointer;
	transition: all 0.1s linear;
	background-clip: padding-box;
	border: 8px solid transparent;
	display: flex;
	align-items: center;
	justify-content: center;
}

.item:hover {
	background-color: $green;
	color: #fff;
}

.active {
	background-color: $blue;
	color: #fff;
}

p {
	color: #c2c0bf;
	font-family: "Nunito Sans";
	font-size: 14px;
	letter-spacing: -0.14px;
	line-height: 19px;
	display: block;
}

.pci h4 {
	line-height: 1;
}

.pci {
	margin-top: 30px !important;
	border: 2px solid #e7e7e7;
	border-radius: 8px;
	padding: 30px;
}

.pci p {
	color: #686361;
	font-family: "Nunito Sans";
	font-size: 15px;
	margin-bottom: 0;
	line-height: 1;
	letter-spacing: 0;
}

@media only screen and (max-width: 1024px) {
	.item {
		padding: 8px 0;
		margin: 5px 0;
	}

	.pci {
		padding: 20px 15px;
	}

	.pci p {
		font-size: 14px;
	}

	.confirm {
		padding: 0px;
	}

	.item {
		border: none;
	}
}
</style>
